import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-save-assign-representative-distributer-dailog-componentgranth',
  // standalone: true,
  // imports: [],
  templateUrl: './save-assign-representative-distributer-dailog-componentgranth.component.html',
  styleUrl: './save-assign-representative-distributer-dailog-componentgranth.component.scss'
})
export class SaveAssignRepresentativeDistributerDailogComponentgranthComponent {
  AssignDisRepForm: FormGroup;
  
    distributorList: any[] = [];
    subDeliveryModeData: any[] = [];
    subDistributionModeData: any[] = [];
    FilteredsubDistributionModeData: any[] = [];
  
    filteredOptions14!: Observable<any[]>;
    filteredOptions15!: Observable<any[]>;
    filteredOptions16!: Observable<any[]>;
  
    issueSellerName: any;
    id: any;
    dis_mode: any;
    dis_sub_mode: any;
    objectData: any;
  
    constructor(
      private fb: FormBuilder,
      private service: DigisubservicesService,
      public dialog: MatDialog,
  
      private dialogRef:
        MatDialogRef<SaveAssignRepresentativeDistributerDailogComponentgranthComponent>,
  
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {
  
      this.AssignDisRepForm = this.fb.group({
        id: [''],
        disrep1: [''],
        dismode: [''],
        dissubmode: ['']
      });
    }
  
    ngOnInit(): void {
  
      this.issueSellerName = this.data?.issueSellerName;
      this.id = this.data?.id;
      this.dis_mode = this.data?.dis_mode;
      this.dis_sub_mode = this.data?.dis_sub_mode;
      this.objectData = this.data?.objectData;
  
      if (this.id === '') {
        this.id = undefined;
      }
  
      this.AssignDisRepForm.patchValue({
        id: this.id,
        disrep1: this.issueSellerName,
        dismode: this.dis_mode,
        dissubmode: this.dis_sub_mode
      });
  
      this.loadDistributorData();
      this.getSubDeliveryModes1();
      this.getSubDistributionModes1();
    }
  
    // DISTRIBUTOR
  
    loadDistributorData(): void {
  
      this.service.getDistributorData1().subscribe((data: any) => {
  
        this.distributorList = data.data || data || [];
  
        this.filteredOptions14 =
          this.AssignDisRepForm.get('disrep1')!.valueChanges.pipe(
            startWith(''),
            map(value => value || ''),
            map(value => this.filterDistributor(value))
          );
      });
    }
  
    filterDistributor(value: string): any[] {
  
      const filterValue = value.toLowerCase();
  
      return this.distributorList.filter(item =>
        item.name?.toLowerCase().includes(filterValue)
      );
    }
  
    // DELIVERY MODE
  
    getSubDeliveryModes1(): void {
  
      this.service.getSubDeliveryMode3().subscribe((res: any) => {
  
        this.subDeliveryModeData = res.data || res || [];
  
        this.filteredOptions15 =
          this.AssignDisRepForm.get('dismode')!.valueChanges.pipe(
            startWith(''),
            map(value => value || ''),
            map(value => this.filterDeliveryMode(value))
          );
      });
    }
  
    filterDeliveryMode(value: string): any[] {
  
      const filterValue = value.toLowerCase();
  
      return this.subDeliveryModeData.filter(item =>
        item.sub_delivery_mode?.toLowerCase().includes(filterValue)
      );
    }
  
    // SUB DELIVERY MODE
  
  getSubDistributionModes1(): void {
    debugger;
  
    this.service.getAllSubDistributionModes1().subscribe((res: any) => {
  
      this.subDistributionModeData = res.data || res || [];
  
      this.filteredOptions16 = this.AssignDisRepForm
        .get('dissubmode')!
        .valueChanges.pipe(
          startWith(''),
          map((value: string) => value || ''),
          map((name: string) =>
            name
              ? this._filter30(name)
              : this.subDistributionModeData.slice()
          )
        );
    });
  }
  
  private _filter30(value: string): any[] {
    const filterValue = value.toLowerCase();
  
    return this.subDistributionModeData.filter((option: any) =>
      option.subdeliverymode
        ?.toLowerCase()
        .includes(filterValue)
    );
  }
  
    filterSubMode(value: string): any[] {
  
      const filterValue = value.toLowerCase();
  
      return this.FilteredsubDistributionModeData.length
        ? this.FilteredsubDistributionModeData.filter(item =>
            item.subdeliverymode?.toLowerCase().includes(filterValue)
          )
        : this.subDistributionModeData.filter(item =>
            item.subdeliverymode?.toLowerCase().includes(filterValue)
          );
    }
  
    distributionMode(event: any, option: any): void {
  
      if (event.isUserInput) {
  
        const id = option.id;
  
        this.FilteredsubDistributionModeData =
          this.subDistributionModeData.filter(
            x => x.sub_deliver_mode_id == id
          );
  
        this.AssignDisRepForm.patchValue({
          dissubmode: ''
        });
      }
    }
  
  assignDistributionMode(): void {
  
    const data = {
      disrep: this.AssignDisRepForm.value.disrep1 || '',
      dismode: this.AssignDisRepForm.value.dismode || '',
      dissubmode: this.AssignDisRepForm.value.dissubmode || ''
    };
  
    console.log("SENDING:", data);
  
    this.service.addAssignDistributionMode2(data)
      .subscribe({
        next: (res) => {
          console.log(res);
          alert('Saved Successfully');
        },
        error: (err) => {
          console.error("API ERROR:", err);
          alert('API Error - Check console');
        }
      });
  }
  
    updateassignDistributionMode(): void {
  
      const data = {
        id: this.id,
        disrep: this.AssignDisRepForm.value.disrep1,
        dismode: this.AssignDisRepForm.value.dismode,
        dissubmode: this.AssignDisRepForm.value.dissubmode
      };
  
      this.service.updateAssignDistributionMode(data)
        .subscribe(() => {
  
          alert(
            'Distribution Mode Updated Successfully'
          );
        });
    }
  
    closeWithData(): void {
  
      this.objectData.issueSellerName =
        this.AssignDisRepForm.value.disrep1;
  
      this.objectData.dis_mode =
        this.AssignDisRepForm.value.dismode;
  
      this.objectData.dis_sub_mode =
        this.AssignDisRepForm.value.dissubmode;
  
      this.dialogRef.close(this.objectData);
    }
  }


